import type { EventData } from './eventPublishing'

/**
 * Sanitize event properties by removing properties not valid for sending to FullStory.
 * Remove __typename.
 * @param eventProperties
 * @returns
 */
export function sanitizeEventProperties(eventProperties: EventData) {
  const sanitized = {} as EventData
  for (const key in eventProperties) {
    if (key !== '__typename') {
      sanitized[key] = eventProperties[key]
    }

    const value = eventProperties[key]
    if (value && value.constructor.name === 'Object') {
      sanitized[key] = sanitizeEventProperties(
        eventProperties[key] as EventData
      )
    }
  }

  return sanitized
}
